import backicon from "../../../assets/images/backicon.svg";
import styled from "styled-components";
import { Row, Col, message, Tooltip } from "antd";
import deleteicon from "../../../assets/images/delete-3-svgrepo-com.svg";
import edit from "../../../assets/images/edit-1-svgrepo-com.svg";
import { useLocation } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import dayjs from "dayjs";
import {
  FuelTypeEnum,
  statusEnum,
  Transmission,
} from "../../../Common/constant";
import { useNavigate } from "react-router-dom";
import UIModal from "../../../Reusablecomponents/UIModal";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
const noop = () => {};
const Customstyle = styled.div`
  padding: 15px;
  /* .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
  } */
  /* .head1,
  .status {
    display: flex;
    align-items: center;
    gap: 10px;
  } */
  /* .status {
    margin-right: 40px;
  } */
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .head1 {
    display: flex;
    gap: 20px;
    width: 60%;
    align-items: center;
  }
  .status {
    display: flex;
    width: 40%;
    gap: 20px;
    justify-content: flex-end;
    align-items: center;
  }
  @media (max-width: 480px) {
    .status {
      width: 100%;
    }
    .head1 {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
    gap: 15px;
    justify-content: flex-start;
  }

  .title1 {
    font-weight: 500;
    font-size: 16px;
    margin-top: 15px;
  }
  .icons {
    display: flex;
    gap: 30px;
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    margin-top: 10px;
  }
  .ant-switch-checked {
    background-color: #31ab46 !important; /* Green color */
  }
  .company {
    font-size: 14px;
    font-weight: 400;
    color: #5f6d8c;
  }
  .data {
    font-weight: 400;
    font-size: 16px;
  }
  .ant-tabs-tab {
    font-size: 18px !important;
    font-weight: 500 !important;
    color: #5f6d8c !important;
    border-radius: 27px !important;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2c963d !important;
  }
  .ant-tabs-tab:hover {
    color: #5f6d8c !important; /* Darker green on hover */
  }
  .tabstyle {
    display: flex;
    justify-content: space-between;
    border-radius: 27px !important;
  }
  .backicon {
    margin-bottom: 5px;
  }
  @media (max-width: 480px) {
    .status_menu_customization {
      width: auto;
      display: flex;
      flex-direction: row;
    }
    .status_menu_two {
      display: flex;
      flex-direction: column;
      gap: 15px;
      align-items: flex-end;
    }
    .head {
      align-items: flex-start;
      flex-direction: column;
    }
    .ant-tabs-nav-list {
      flex-wrap: wrap;
    }
  }
`;
const VehicleDetails = ({
  setIsView = noop,
  setFormData1 = noop,
  handleDelete = noop,
  setOpen1 = noop,
  setIsEditVehicle = noop,
  setActiveKey = noop,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // To store the ID of the consignment to delete
  const [record, setRecord] = useState(location.state || {});
  const [CustomData, setCustomData] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const vehicleType = useSelector((state) => state?.authTracking?.vehicleType);
  const allEntityList = useSelector(
    (state) => state?.authTracking?.allEntityList,
  );
  const officeLists = useSelector((state) => state?.authTracking?.officeList);
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const supllierList = useSelector(
    (state) => state?.authTracking?.supllierList,
  );
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const vehUpdateAllowed = useMemo(
    () => hasPermission("VEHICLE", "U"),
    [reduxPermissions],
  );
  const vehDeleteAllowed = useMemo(
    () => hasPermission("VEHICLE", "D"),
    [reduxPermissions],
  );
  const getcustomedatabyRefId = async () => {
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Vehicle",
        RefId: record?.UID,
        Active: 1,
        McId: userInfo?.MCID,
      });

      if (Array.isArray(data)) {
        setCustomData(data);
      } else if (typeof data === "object" && data !== null) {
        // Wrap the single object in an array
        setCustomData([data]);
      } else {
        setCustomData([]);
        console.warn("Unexpected custom data format:", data);
      }
    } catch (error) {
      console.error("Error fetching custom data:", error);
      setCustomData([]);
    }
  };
  useEffect(() => {
    if (location.state) {
      setRecord(location.state);
    }
  }, [location.state]);
  useEffect(() => {
    getcustomedatabyRefId();
  }, [currentPage, pageSize]);

  const deleteVehicleById = async (vehId) => {
    if (!vehId) return;
    await CALL_API("Delete", `mastertable/delete_vehicles`, {
      VehId: vehId,
    });
    await CALL_API("DELETE", `mastertable/deleteCustomDataByRef`, {
      RefId: vehId,
      RefTab: "Vehicle",
      McId: userInfo?.MCID,
    });
  };

  const handleDetailDelete = async (vehId) => {
    if (!vehId) return;
    const canUseParentHandler = handleDelete !== noop;
    setIsDeleting(true);
    try {
      if (canUseParentHandler) {
        await handleDelete(vehId);
      } else {
        await deleteVehicleById(vehId);
        message.success("Vehicle Deleted Successfully");
      }
      setIsView(false);
      navigate("/MasterTable");
    } catch (error) {
      console.error("Vehicle delete failed:", error);
      message.error("Failed to delete vehicle. Please try again.");
    } finally {
      setIsDeleteModalVisible(false);
      setDeleteId(null);
      setIsDeleting(false);
    }
  };

  const columns = [
    {
      title: "Event",
      dataIndex: "EVTYPE",
      key: "EVTYPE",
    },
    {
      title: "Updated on",
      dataIndex: "CREATED",
      key: "CREATED",
    },
    {
      title: "Updated by",
      dataIndex: "UserName",
      key: "UserName",
    },
    {
      title: "Location",
      dataIndex: "LOCATION",
      key: "LOCATION",
    },
    {
      title: "Consignment",
      dataIndex: "CONSIGN",
      key: "CONSIGN",
    },
  ];

  const data = [
    {
      key: "1",
      OFFNM: "",
      ADDRESS: "",
      LONGITUDES: "",
      LOCATION: "",
      CONSIGN: "",
    },
  ];
  return (
    <>
      <Customstyle>
        <div className="head">
          <div className="head1">
            <div className="backicon">
              <img
                src={backicon}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/MasterTable");
                }}
              />
            </div>
            <div className="title">
              <p>Vehicle Details - {record?.REGNO || "-"}</p>
            </div>
          </div>

          <div className="status ">
            <div className="icons">
              <Tooltip title={!vehUpdateAllowed ? "No permission" : ""}>
                <img
                  src={edit}
                  style={{
                    cursor: vehUpdateAllowed ? "pointer" : "not-allowed",
                  }}
                  onClick={() => {
                    if (!vehUpdateAllowed) return;
                    setFormData1({
                      VehId: record?.VEHID,
                      vehicleno: record?.REGNO,
                      vehicletype: record?.VTYPEID,
                      model: record?.MODEL,
                      capacity: record?.CUBICCAPACITY,
                      tones: record?.TONNES,
                      link: record?.LINKTO,
                      status: record?.STATUS,
                      chassisno: record?.CHASISNO,
                      engineno: record?.ENGINENO,
                      transmission: record?.TRANSMISSION,
                      entity: record?.ENTID,
                      UID: record?.CRBY,
                      MCID: record?.MCID,
                      supplier: record?.SUPPLIER,
                      driver: record?.DRIVER,
                      office: record?.OFFID,
                      Deleted: record?.DELETED,
                      cc: record?.CC,
                      mileage: record?.Mileage,
                      odo: record?.OdoResetOn ? dayjs(record?.OdoResetOn) : "",
                      fueltype: record?.FuelType,
                      ConsignorId: record?.CONSIGNORID,
                      RegistrationDate: record.REGDATE
                        ? dayjs(record.REGDATE)
                        : "",
                      mfgyear: record?.MFGYEAR ? dayjs(record?.MFGYEAR) : "",
                      dimension: `${record?.Length}/${record?.Width}/${record?.Height}`,
                    });
                    setOpen1(true);
                    setIsEditVehicle(true);
                  }}
                />
              </Tooltip>
              <Tooltip title={!vehDeleteAllowed ? "No permission" : ""}>
                <img
                  src={deleteicon}
                  style={{
                    cursor: vehDeleteAllowed ? "pointer" : "not-allowed",
                  }}
                  onClick={() => {
                    if (!vehDeleteAllowed) return;
                    setIsDeleteModalVisible(true);
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
        <UIModal
          width={500}
          open={isDeleteModalVisible}
          onClose={() => {
            setIsDeleteModalVisible(false);
            setDeleteId(null); // Reset the delete ID
          }}
          closeButton={false}
          size="md"
          header={false}
          footer={false}
        >
          <div className="text-center">
            <h1>Are you sure,</h1>
            <h6>You want to delete this Vehicle?</h6>
            <div className="mt-2 w-100 d-flex justify-content-center">
              <ButtonFilled
                loading={isDeleting}
                onClick={() => handleDetailDelete(record?.VEHID)}
              >
                Yes
              </ButtonFilled>
              <Buttontransparent
                onClick={() => {
                  setIsDeleteModalVisible(false); // Close the modal
                  setDeleteId(null); // Reset the delete ID
                }}
              >
                No
              </Buttontransparent>
            </div>
          </div>
        </UIModal>
        <div style={{ padding: "20px" }}>
          <Row gutter={[24, 24]}>
            <Col sm={12} md={6}>
              <p className="company">Vehicle No</p>
              <p> {record?.REGNO || "-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              {" "}
              <p className="company">Vehicle Type</p>
              <p className="data">
                {vehicleType?.find((item) => item.ID === record.VTYPEID)
                  ?.NAME || "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Model</p>
              <p className="data"> {record?.MODEL || "-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Mfg Year</p>
              <p className="data"> {record?.MFGYEAR || "-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Internal Dimension of truck</p>
              <p className="data">
                {`${record?.Length}/${record?.Width}/${record?.Height}` ||
                  "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Cubic Capacity</p>
              <p className="data"> {record?.CUBICCAPACITY || "-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Maximum Load Capacity (in Kg)</p>
              <p className="data">{"-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Fuel Type</p>
              <p className="data">
                {FuelTypeEnum?.find((item) => item.value === record.FuelType)
                  ?.name || "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Tonnes</p>
              <p className="data">{record?.TONNES || "-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Link to</p>
              <p className="data">{record?.LINKTO || "-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Status</p>
              <p className="data">
                {statusEnum?.find((item) => item.value === record.STATUS)
                  ?.name || "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Mileage</p>
              <p className="data">{record?.Mileage || "-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">ODO Reset on</p>
              <p className="data">
                {dayjs(record?.OdoResetOn).format("DD/MM/YYYY HH:mm:ss") ||
                  "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Registration Date</p>
              <p className="data">
                {dayjs(record?.REGDATE).format("DD/MM/YYYY") || "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Chassis Number</p>
              <p className="data">{record?.CHASISNO || "-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Engine Number</p>
              <p className="data">{record?.ENGINENO || "-/-"}</p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Transmission</p>
              <p className="data">
                {Transmission?.find(
                  (item) => item.value === record.TRANSMISSION,
                )?.name || "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Entity</p>
              <p className="data">
                {allEntityList?.find((item) => item.ID === record.ENTID)
                  ?.Name || "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Supplier</p>
              <p className="data">
                {supllierList?.find((item) => item.ID === record.SUPPLIER)
                  ?.Name || "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Driver</p>
              <p className="data">
                {driverList?.find((item) => item.UID === record.DRIVER)
                  ?.FULLNM || "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <p className="company">Office</p>
              <p className="data">
                {officeLists?.find((item) => item.OFFID === record.OFFID)
                  ?.OFFNM || "-/-"}
              </p>
            </Col>
            <Col sm={12} md={6}>
              {Array.isArray(CustomData) &&
                CustomData.length > 0 &&
                CustomData.map((field) => (
                  <div className="consignor_code" key={field.CFID}>
                    <label>{field.FIELDNAME}</label>
                    <p>{field.VALUE || "-/-"}</p>
                  </div>
                ))}
            </Col>
          </Row>
        </div>
        <br />
        <div>
          <p
            style={{
              fontWeight: "500",
              fontStyle: "Medium",
              fontSize: "18px",
            }}
          >
            Location
          </p>
          <br />
          <StyledTable dataSource={data} columns={columns} pagination={false} />
        </div>
      </Customstyle>
    </>
  );
};

export default VehicleDetails;
